<template>
  <div>
    <div id="391545128">
      <script2 type="text/javascript">
        try {
          window._mNHandle.queue.push(function (){
            window._mNDetails.loadTag("391545128", "728x90", "391545128");
          });
        }
        catch (error) {}
      </script2>
    </div>
    <p>Built with <a href="https://vuejs.org/">vue.js</a></p>
    <p v-if="this.$route.path != '/'"><router-link to="/">Go back to main page</router-link></p>
  </div>
</template>

<script>
  export default {
    name: 'Footer'
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
</style>
